export const INVOICES_API_URL = 'ui/organization/payments';

export const invoicesQueryKeys = {
  all: [INVOICES_API_URL],
  list: () => [...invoicesQueryKeys.all, 'list'],
};
